<template>
    <div class="password-recovery">
        <h3>Recuperación de Contraseña</h3>
        <b-form @submit.prevent="submit" class="mt-3">

            <b-form-group label="Método de recuperación" label-for="method">
                <b-form-select v-model="method" :disabled="step != 'request' || true">
                    <b-form-select-option value="email">Email</b-form-select-option>
                    <b-form-select-option value="phone">Teléfono principal</b-form-select-option>
                </b-form-select>
            </b-form-group>

            <b-form-group v-if="method === 'email'" label="Email" label-for="email">
                <b-form-input id="email" v-model="email" :disabled="step != 'request'" type="email" required
                    autocomplete="email" placeholder="Ingresa tu email" />
            </b-form-group>

            <b-form-group v-else label="Teléfono principal" label-for="phone">
                <b-form-input id="phone" v-model="phone" :disabled="step != 'request'" type="tel" required
                    autocomplete="tel" placeholder="P. e: +1234567890" />
            </b-form-group>

            <b-button type="submit" variant="primary" :disabled="processing" v-if="['request'].indexOf(step) != -1"
                block>
                {{ processing ? 'Enviado...' : 'Solicitar recuperación' }}
            </b-button>

            <template v-if="['recover', 'reset'].indexOf(step) != -1">

                <p class="message">Se ha enviado un enlace de recuperación al método seleccionado.</p>

                <b-form-group label="Código de validación" label-for="email">
                    <b-form-input id="codigo" v-model="codigo" :disabled="step != 'recover'" required
                        placeholder="P. e: 993311" />
                </b-form-group>

                <b-button variant="primary" :disabled="processing" v-if="['recover'].indexOf(step) != -1"
                    @click="validateCode" block>
                    {{ processing ? 'Consultando...' : 'Confirmar código' }}
                </b-button>

                <b-button variant="link" @click="step = 'request'" v-if="step == 'recover'">
                    Intentar otro método
                </b-button>

                <template v-if="step == 'reset'">

                    <b-form-group label="Nueva contraseña" label-for="password">
                        <b-form-input id="password" v-model="password" type="password" required
                            placeholder="Nueva contraseña" />
                    </b-form-group>

                    <b-form-group v-if="password !== ''" label="Confirmar contraseña" label-for="password_confirmation">
                        <b-form-input id="password_confirmation" v-model="password_confirmation" type="password"
                            required placeholder="Confirma la nueva contraseña"
                            :state="password_confirmation === '' || password_confirmation === password" />
                        <b-form-invalid-feedback
                            v-if="password_confirmation !== '' && password_confirmation !== password">
                            Las contraseñas no coinciden.
                        </b-form-invalid-feedback>
                    </b-form-group>

                </template>

                <b-button variant="primary" :disabled="processing" v-if="['reset'].indexOf(step) != -1"
                    @click="updatePassword" block>
                    {{ processing ? 'Procesando...' : 'Actualizar contraseña' }}
                </b-button>


            </template>
        </b-form>
    </div>
</template>

<script>
import axios from 'axios';
import { notify } from '@/js/utils.js';
function quickResponseTreatment(response) {
    if (!response.status) {
        throw response.msg || "Error al procesar la solicitud.";
    } else if (response.msg) {
        notify(response.msg, response.class);
    }
}
export default {
    name: "PasswordRecovery",
    data() {
        return {
            step: "request",    // "request", "recover" or "reset"
            method: "email",
            email: "",
            phone: "",
            processing: false,
            codigo: "",
            password: "",
            password_confirmation: ""
        };
    },
    methods: {
        async updatePassword() {
            this.processing = true;
            let response;
            try {
                if (this.codigo === "")
                    throw ("El código de validación es obligatorio.");
                if (this.password.length < 6)
                    throw ("La contraseña debe tener al menos 6 caracteres.");
                if (this.password !== this.password_confirmation)
                    throw ("Las contraseñas no coinciden.");


                let payload = {
                    password: this.password,
                    password_confirmation: this.password_confirmation,
                    codigo: this.codigo
                };
                if (this.method === "email") {
                    payload.email = this.email;
                    response = await axios.post("password/reset_email", payload);
                } else {
                    payload.phone = this.phone;
                    response = await axios.post("password/reset_phone", payload);
                }
                quickResponseTreatment(response);
                if (response.status) {
                    this.step = "request";
                    this.email = "";
                    this.phone = "";
                    this.codigo = "";
                    this.password = "";
                    this.password_confirmation = "";
                    this.$emit("passwordUpdated", true);
                }
            } catch (e) {
                notify(e);
            } finally {
                this.processing = false;
            }
        },
        async validateCode() {
            this.processing = true;
            let response;
            try {
                if (this.method === "email") {
                    response = await axios.post("password/validate_email", { email: this.email, codigo: this.codigo });
                } else {
                    response = await axios.post("password/validate_phone", { phone: this.phone, codigo: this.codigo });
                }
                quickResponseTreatment(response);
                if (response.status) {
                    this.step = "reset"
                }
            } catch (e) {
                notify(e);
            } finally {
                this.processing = false;
            }
        },
        async submit() {
            this.processing = true;
            let response;
            try {
                if (this.method === "email") {
                    response = await axios.post("password/email", { email: this.email });
                } else {
                    response = await axios.post("password/phone", { phone: this.phone });
                }
                quickResponseTreatment(response);
                if (response.status) {
                    this.step = "recover"
                }
            } catch (e) {
                notify(e);
            } finally {
                this.processing = false;
            }
        },
    },
};
</script>

<style lang="scss">
.password-recovery {
    .message {
        color: var(--primary);
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    .error {
        color: var(--danger);
        margin-top: 1rem;
    }
}
</style>